/** What the closer typed into the adjust or drop form, or the message that says what to fix. The server checks again; this only saves the round trip. */
export function decisionFormProblem(form: { mode: 'adjusted' | 'dropped'; quantity: number | null; reason: string }): string | null {
  if (form.reason.trim() === '') return 'Give a reason: it is kept with the decision.';
  if (form.mode === 'dropped') return null;
  const isWholeQuantity = form.quantity !== null && Number.isInteger(form.quantity) && form.quantity >= 1;
  return isWholeQuantity ? null : 'Enter a whole quantity of at least 1.';
}
